import React, { useState } from "react";
import PaperColorForm from "../forms/PaperColorForm";
import { deleteIcon, editIcon } from "../../icon";
import DeletePaperColorModal from "../forms/DeletePaperColorModal";
import { useAuth } from "../../../contexts/auth";

export default function TabBodyPaperColor({
  paperColorData,
  setPaperColorData,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [paperColorToEdit, setPaperColorToEdit] = useState(null);
  const [paperColorToDelete, setPaperColorToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  return (
    <div className="relative">
      <div className="flex justify-between bg-gray-200 items-center p-2 rounded-md mb-4">
        <button
          onClick={() => {
            setPaperColorData(null);
          }}
          className="bg-orange text-white p-2 rounded-md"
        >
          Back
        </button>
        <p>{paperColorData.paper}</p>
        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => {
              setIsOpen(true);
            }}
            className="bg-orange text-white p-2 rounded-md"
          >
            Add Paper Color
          </button>
        )}
      </div>

      <table className="dataTable">
        <thead>
          <tr>
            <th scope="col">No.</th>
            <th scope="col">Paper Color</th>
            <th scope="col">Note</th>
            {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
          </tr>
        </thead>
        <tbody>
          {paperColorData?.color &&
            paperColorData.color.map(({ id, note, color }, i) => {
              return (
                <tr key={id}>
                  <td scope="col">{i + 1}</td>
                  <td scope="col">{color}</td>
                  <td scope="col">{note}</td>
                  {activeUser?.user_permission <= 2 && (
                    <td scope="col">
                      <button
                        className="bg-green-600 p-2 rounded-md my-1"
                        onClick={() => {
                          setPaperColorToEdit({ id, note, color });
                        }}
                      >
                        {editIcon}
                      </button>
                      <button
                        className="p-2 rounded-md ml-2 bg-orange"
                        onClick={() => {
                          setPaperColorToDelete({ id, note, color });
                        }}
                      >
                        {deleteIcon}
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
      </table>

      <PaperColorForm
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        setPaperColorData={setPaperColorData}
        setPaperColorToEdit={setPaperColorToEdit}
        paperColorToEdit={paperColorToEdit}
        paperColorData={paperColorData}
      />

      <DeletePaperColorModal
        paperColorData={paperColorData}
        setPaperColorData={setPaperColorData}
        paperColorToDelete={paperColorToDelete}
        setPaperColorToDelete={setPaperColorToDelete}
      />
    </div>
  );
}
